import { CreatePropertyInput } from "../../backend/generated/create-property-input";
import { Property } from "../../backend/generated/property-model";
import { prune } from "../../utils/utility";
import { validateRequiredNotDefault } from "../../utils/validation";

export class CreatePropertyManageable extends CreatePropertyInput {
  constructor(obj?: any) {
    super();
    if (obj) {
      obj && Object.assign(
        this,
        CreatePropertyManageable.default(),
        prune(obj)
      );
    } else {
      Object.assign(
        this,
        CreatePropertyManageable.default()
      );
    }
  }

  static readonly required = {
    key: true,
    value: true,
    type: true,
  };

  static default(): any {
    return {
      ...new CreatePropertyInput(),
      properties: [],
    }
  }

  validate(keys: Array<string>): any {
    let errors: any = {};

    validateRequiredNotDefault(
      errors,
      CreatePropertyManageable.required,
      this,
      CreatePropertyManageable.default(),
      keys
    );

    return errors;
  }

  serialize(): any {
    let data: any = Object.assign(
      {},
      this
    );

    data.type = data.type.toUpperCase();

    if (data.properties) {
      data.properties = data.properties.map((property: any) => new CreatePropertyManageable(property).serialize());
    }

    return data;
  }
}

export type PropertyTypeIntersection =
  | CreatePropertyInput
  | Property

export type PropertyInputTypeUnion =
  & CreatePropertyInput

